<template>
  <div class="sms-code">
    <input class="input" ref="codeInput" type="text" v-model="code">
    <h2>请输入验证码</h2>
    <h3>
      发送至{{ phoneNum }}
      <span
        @click="resendCode"
        :class="{ active: isCountDowning }"
      >{{ isCountDowning ? `${countDown}S后重新获取` : '获取验证码' }}</span>
    </h3>
    <div class="code" @click="focusInput">
      <template v-for="(item, index) in codeList">
        <div :key="index" :class="{ active: item != undefined }">{{ item }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { LocalStorageUtil } from '@/utils';
const SMS_CODE_LENGTH = 4;
export default {
  data() {
    return {
      code: '',
      phoneNum: this.$route.query.phoneNum,
      countryCode: this.$route.query.countryCode,
      pcode: this.$route.query.pcode,
      timer: null,
      // coutDown: 0
    };
  },
  mounted() {
    localStorage.setItem('nch5', null);
    if (this.isCountDowning) {
      this.$store.dispatch('smsCode/initTimer');
    }
  },
  methods: {
    ...mapMutations({
      setLoading: 'setLoadingShow',
    }),
    focusInput() {
      this.$refs.codeInput.focus();
    },
    async login() {
      this.setLoading({ show: true, text: '正在验证' });
      let data = {
        phoneNum: this.phoneNum,
        smsCode: this.code,
        anonymousId: this.$eventTrack.getAnonymousId(),
      };
      if (LocalStorageUtil.getContextId()) {
        data.inviteCode = LocalStorageUtil.getContextId();
      }
      let result = await this.$api.account_v1_sms_login_post({ data });
      this.setLoading({ show: false });
      if (result) {
        this.loginSuccess(result);
      } else {
        this.focusInput();
      }
    },
    async loginSuccess(result = {}) {
      if (result.isRegister) {
        let activityData = {
          activityId: 1,
          source: 2,
        };
        // if (LocalStorageUtil.getContextId()) {
        //   activityData.inviteCode = LocalStorageUtil.getContextId()
        // }
        // this.$api.activity_user_draw_times_post({
        //   data: activityData,
        // })
        // localStorage.setItem('readingFestival', result.user.uid)
      }
      this.$store.commit('auth/accessToken', result.accessToken);
      await this.$store.dispatch('auth/getUserInfo');
      let redirect = this.$route.query.redirect;
      delete this.$route.query.redirect;
      this.$router.replace({
        path: redirect || '/',
        // query: Object.assign({}, this.$route.query),
      });
    },
    resendCode() {
      this.$store.dispatch('smsCode/sendSms', {
        phoneNum: this.phoneNum,
        countryCode: this.countryCode,
        pcode: this.pcode,
        module: 'login',
      });
    },
  },
  watch: {
    code(val) {
      if (val.length == SMS_CODE_LENGTH) {
        this.$refs.codeInput.blur();
        this.login();
      }
    },
  },
  computed: {
    ...mapGetters({
      countDown: 'smsCode/countDown',
      isCountDowning: 'smsCode/isCountDowning',
    }),
    codeList() {
      let arr = this.code.split('');
      arr.length = SMS_CODE_LENGTH;
      return arr;
    },
  },
};
</script>

<style scoped>
.sms-code {
  padding: 0 36px;
}
.sms-code h2 {
  color: #4e9df6;
  font-size: 30px;
  padding-top: 32px;
  font-weight: bold;
}
.sms-code h3 {
  color: #244352;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  margin-top: 5px;
}
.sms-code h3 span {
  margin: 0 0 0 auto;
  color: #22c5c5;
}
.sms-code h3 span.active {
  color: #d0d0d0;
}
.code {
  display: flex;
  justify-content: space-between;
  margin: 24px 0 10px;
}
.code > div {
  width: 64px;
  height: 80px;
  line-height: 80px;
  font-size: 30px;
  text-align: center;
  flex: 0 0 auto;
  border: 1px solid #d0d0d0;
  opacity: 1;
  border-radius: 8px;
  color: #244352;
  transition: all 0.3s;
}
.code > div.active {
  border: 1px solid rgba(34, 197, 197, 1);
}
.validatorText {
  font-size: 12px;
  line-height: 17px;
  color: #fe2c2a;
}
.input {
  opacity: 0;
  height: 0;
  display: 0;
}
</style>
